import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IRuleDto } from "../interface/user/login/IRuleDto";
import { IFillSelect } from '../interface/generic/IFillSelect';

enum RuleServiceEnum {
  getAllBasic = "/get-basic",
  getAll = "/",
  save = "",
  getById = "/"
}

export default class RuleService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/rule");
  }

  public getAllBasic = async (): Promise<IFillSelect[]> => await this.GET(RuleServiceEnum.getAllBasic);
  public getAll = async (): Promise<IRuleDto[]> => await this.GET(RuleServiceEnum.getAll);
  public save = async (data): Promise<any> => await this.POST(RuleServiceEnum.save, data);
  public getById = async (id): Promise<any> => await this.GET(RuleServiceEnum.getById + id);
}
